import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { StyledAIResultsListGroupItem } from "../_components/styled/ai/styledAi";
import {
  COPIES_ENDPOINT,
} from "../_actions/endpoints";
import axios from "axios";
import Format from "string-format";
import { ShowCenterSpinner } from "../_components/common/statelessView";
import { handleHTTPError } from "../_actions/errorHandlerActions";
import { connect, useDispatch } from "react-redux";
import connectedFeatureAvailabilityWrapper from "../_components/common/withFeatureAvailability";
import {
  newAiresults,
  prependAiResults,
} from "../_actions/aiDocumentActions";
import {
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Textarea,
  Tooltip,
  ButtonGroup,
  Flex,
  Text,
  Box,
  Icon,
} from "@chakra-ui/react";
import {
  FaBan,
  FaEllipsisV,
  FaFlag,
  FaHeart,
  FaPencilAlt,
  FaPlus,
  FaTrash,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { Clipboard } from "../_utils/copyToClipboard";
import TLDRInfiniteScroll from "../_components/common/TLDRInfiniteScroll";
import { MAIN_CONTAINER_SCROLLABLE_TARGET_ID } from "../_utils/constants";

function AiResults(props) {
  const { t } = useTranslation(["ai", "common", "billing", "accounts"]);
  let signalToken = axios.CancelToken.source();
  const [copyId, setCopied] = useState(null);
  const [copied, setTextCopied] = useState(false);
  const [submit, isSubmitting] = useState(false);
  const [selected, setSelectedResults] = useState({});
  const [editing, setEditing] = useState();
  const [saving, setSaving] = useState(false);
  const [text, setText] = useState();
  const [workspacePermissionChecks, setPermissionChecks] = useState(
    props.workspacePermissionChecks
  );

  const dispatch = useDispatch();

  useEffect(() => {
    setPermissionChecks(props.workspacePermissionChecks);
  }, [props.workspacePermissionChecks]);

  function updateState(copy, state, index) {
    axios
      .patch(
        Format(COPIES_ENDPOINT, copy.id),
        { status: state },
        {
          cancelToken: signalToken.token,
        }
      )
      .then((res) => {
        props.onStateUpdate(state, res.data);
      })
      .catch((error) => {
        dispatch(handleHTTPError(error, props));
      });
  }

  function deleteCopy(id) {
    axios
      .delete(Format(COPIES_ENDPOINT, id), {
        cancelToken: signalToken.token,
      })
      .then((res) => {
        props.onDelete(id);
      })
      .catch((error) => {
        dispatch(handleHTTPError(error, props));
      });
  }

  function updateSelection(result) {
    if (selected[result.id]) {
      delete selected[result.id];
    } else {
      selected[result.id] = result.payload;
    }
    setSelectedResults({ ...selected });
    props.selectedResults({ ...selected });
  }

  function updateHeadline(copy, value, index) {
    setSaving(true);
    const apiBody = {
      payload: {
        headline: value,
      },
    };
    axios
      .patch(Format(COPIES_ENDPOINT, copy.id), apiBody, {
        cancelToken: signalToken.token,
      })
      .then((res) => {
        setSaving(false);
        props.onStateUpdate("update", res.data)
      })
      .catch((error) => {
        setSaving(false);
        dispatch(handleHTTPError(error, props));
      });
  }

  function addNow(result) {
    if (props.handleDocumentAddNow) {
      props.handleDocumentAddNow(result);
    }
  }
  const template = props?.document?.prompt?.template;

  const { canDeleteAIDocumentCopy, canEditAIDocumentCopy } =
    workspacePermissionChecks;
  const resultsView = props?.airesults?.map((result, index) => {
    return (
      <Fragment key={`${index}${result.id}`}>
        {result?.payload && (
          <Box
            as={StyledAIResultsListGroupItem}
            hoverEnabled={true}
            key={`${result.id}${index}`}
            className={selected[result.id] ? "active" : ""}
            mb={2}
            pl={3}
            pb={4}
            pt={1}
          >
            <Flex
              flexDirection="column"
              key={`col1_${result.id}`}
              w="full"
              cursor="default"
            >
              <Flex py="0.5" justifyContent="space-between" alignItems="center">
                <Text
                  key={`ts1_${result.id}`}
                  color="gray.300"
                  px="0.5"
                  fontSize="12px"
                  fontWeight="normal"
                >
                  {result.modified}
                </Text>
                <Box key={`ts2_${result.id}`}>
                  {props.type === "longform" && (
                    <Tooltip hasArrow placement="bottom" label={t("add")}>
                      <IconButton
                        icon={<FaPlus />}
                        onClick={(event) => {
                          event.stopPropagation();
                          addNow(result);
                        }}
                        variant="unstyled"
                        size="sm"
                      />
                    </Tooltip>
                  )}

                  <Tooltip
                    hasArrow
                    label={t("add_to_fav")}
                    placement="bottom"
                    shouldWrapChildren
                  >
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation();
                        updateState(result, result.status === "draft"? "saved" : "draft");
                      }}
                      icon={<FaHeart />}
                      variant="unstyled"
                      isActive={result.status === "saved"}
                      _active={result.status === "saved" && { color: "brand.candy" }}
                      size="sm"
                    />
                  </Tooltip>


                  <Tooltip
                    hasArrow
                    label={t("copy_to_clipboard")}
                    placement="bottom"
                    shouldWrapChildren
                  >
                    <Clipboard
                      value={
                        result.payload?.cta
                          ? result.payload.headline + "\n" + result.payload.cta
                          : result.payload.headline
                      }
                      withText={false}
                    />
                  </Tooltip>

                  <Tooltip
                    label={t("move_trash", { ns: "common" })}
                    placement="bottom"
                    hasArrow
                  >
                    <IconButton
                      icon={<FaTrash />}
                      variant="unstyled"
                      onClick={(event) => {
                        event.stopPropagation();
                        deleteCopy(result.id);
                      }}
                      size="sm"
                    />
                  </Tooltip>

                  <Menu isLazy>
                    <MenuButton
                      as={IconButton}
                      icon={<FaEllipsisV />}
                      variant="unstyled"
                      size="sm"
                    />
                    <MenuList>
                      <MenuItem
                        onClick={(e) => {
                          e.stopPropagation();
                          setEditing(result.id);
                        }}
                        icon={<FaPencilAlt />}
                      >
                        {t("edit", { ns: "common" })}
                      </MenuItem>
                      <MenuItem
                        onClick={(e) => {
                          e.stopPropagation();
                          updateState(result, "flagged", index);
                        }}
                        icon={<FaFlag />}
                      >
                        {result.status === "flagged" ? t("flagged") : t("flag")}
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Box>
              </Flex>

              {editing === result.id ? (
                <>
                  <Box
                    key={`s1_${result.id}`}
                    cursor="pointer"
                    pr={3}
                    className="title"
                    mb={3}
                  >
                    <Textarea
                      height={"150px"}
                      defaultValue={result.payload.headline}
                      autoFocus
                      onFocus={(e) => {
                        e.stopPropagation();
                        setText(e.target.value);
                      }}
                      showBorderOnHover={false}
                      onChange={(e) => {
                        setText(e.target.value);
                      }}
                    />
                  </Box>
                  <div className="ai-result-save-action">
                    <ButtonGroup display="flex" justifyContent="end" mr={3}>
                      <Button
                        size="sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          setEditing(null);
                        }}
                        variant="secondary"
                      >
                        {t("cancel", { ns: "common" })}
                      </Button>
                      <Button
                        size="sm"
                        type="submit"
                        variant="solid"
                        onClick={(e) => {
                          e.stopPropagation();
                          updateHeadline(result, text, index);
                        }}
                        disabled={result.payload.headline === text}
                        isLoading={saving}
                        loadingText={t("saving", { ns: "common" })}
                      >
                        {t("save", { ns: "common" })}
                      </Button>
                    </ButtonGroup>
                  </div>
                </>
              ) : (
                <Text
                  color="brand.white"
                  overflow="hidden"
                  fontFamily="Rubik"
                  fontSize="0.875rem"
                  whiteSpace="break-spaces"
                  key={`s1_${result.id}`}
                  onClick={(event) => {
                    event.preventDefault();
                    if (template === "image") {
                      updateSelection(result);
                    } else {
                      setEditing(result.id);
                    }
                  }}
                  mt={3}
                  mr={3}
                  cursor="pointer"
                >
                  {result.payload.headline}
                </Text>
              )}
            </Flex>
          </Box>
        )}{" "}
      </Fragment>
    );
  });

  return (
    <>
      {props?.airesults?.length > 0 ? (
        <>
          <TLDRInfiniteScroll
            childrens={resultsView}
            hasMore={props.hasMore}
            loadMoreData={props.loadMoreData}
            scrollableTarget={MAIN_CONTAINER_SCROLLABLE_TARGET_ID}
            loaded={false} // Change its value whenever data get loaded.
          />
        </>
      ) : submit ? (
        <Box position="relative" mt={8}>
          <ShowCenterSpinner loaded={!submit} />
        </Box>
      ) : (
        <Flex
          justify="center"
          align="center"
          direction="column"
          height="100%"
          px={15}
          textAlign="center"
          pt={16}
        >
          <Icon as={FaBan} color="gray.100" h={5} w={5} mb={3} />
          <Text fontSize="1rem" color="gray.100" fontWeight={500}>
            {props.noDataTitle}
          </Text>
          <Text fontSize="0.875rem" color="gray.300">
            {t("generate_results")}
          </Text>
        </Flex>
      )}
    </>
  );
}

AiResults.defaultProps = {
  aiResults: [],
};

AiResults.propTypes = {
  aiResults: PropTypes.array.isRequired,
  document: PropTypes.object.isRequired,
  t: PropTypes.func,
};

const mapStateToProps = (state) => ({
  document: state.document.data,
  subscription: state.subscription,
  workspacePermissionChecks: state?.permissions?.workspacePermissionChecks,
  page: state.airesults.page,
  hasmore: state.airesults.hasmore,
  // airesults: state.airesults.payload,
});

const mapDispatchToProps = (dispatch) => {
  return {
    handleHTTPError: (error, props) => dispatch(handleHTTPError(error, props)),
    prependAiResults: (payload) => dispatch(prependAiResults(payload)),
    newAiresults: (payload) => dispatch(newAiresults(payload)),
  };
};

export default connectedFeatureAvailabilityWrapper(
  connect(mapStateToProps, mapDispatchToProps)(AiResults)
);
